import { FC, ReactNode,} from "react";
import TabFilters from "./TabFilters";
import { useFilters } from "./FiltersContext";

export interface HeaderFilterProps {
  // tabActive: string;
  // tabs: string[];
  heading: ReactNode;
  subHeading?: ReactNode;
  onClickTab?: (item: string) => void;
}

const HeaderFilter: FC<HeaderFilterProps> = ({
  // tabActive,
  // tabs,
  // onClickTab,
}) => {
  // const [tabActiveState, setTabActiveState] = useState(tabActive);

  // const handleClickTab = (item: string) => {
  //   onClickTab && onClickTab(item);
  //   setTabActiveState(item);
  // };

  // const searchParams = new URLSearchParams(window.location.search);
  // searchParams.set('location', tabActiveState);
  const {filters, setFilters} = useFilters();

  function handleChange(value) {
    setFilters({
      ...filters,...value
    });
  }

  return (
    <div className="flex flex-col mb-8 relative">
      <TabFilters {...filters} onChange={handleChange}/>
    </div>
  );
};

export default HeaderFilter;
